import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { subscriberRequestPharmacyList } from "../../../redux/actions/customerActions";
import SubscribeTableData from "./subscribeTableData";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../../components/utilites/loader";
import NumberPagination from "../../../components/Pagination/number-pagination";

const SubscribePharmacyTable = ({ search, page_no }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [subscriberReqList, setSubscribeReqList] = useState([]);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    dispatch(
      subscriberRequestPharmacyList({ search, page }, onSuccess, onError)
    );
  }, [page, search]);

  const onSuccess = (data) => {
    setLoading(false);
    console.log(data);
    setSubscribeReqList(data.data.data);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  console.log(subscriberReqList, "subscriberReqList");

  return (
    <>
      <div>
        <div className="table-container">
          <table
            className="main-table text-nowrap"
            style={{ position: "relative" }}
          >
            <thead>
              <tr className="table-rows">
                <th className="table-heads " width={"3%"}>
                  #
                </th>
                <th className="table-heads" width={"12%"}>
                  Pharmacy Code
                </th>
                <th className="table-heads" width={"12%"}>
                  Pharmacy Name
                </th>
                <th className="table-heads" width={"12%"}>
                  Phone
                </th>
                <th className="table-heads" width={"10%"}>
                  Status Of Approval
                </th>
                <th className="table-heads" width={"10%"}>
                  State Of Approval
                </th>
                <th className="table-heads" width={"12%"}>
                  Date & Time
                </th>
                <th className="table-heads" width={"16%"}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody style={{ position: "relative" }}>
              {loading === true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : subscriberReqList?.data?.length > 0 ? (
                <>
                  {subscriberReqList?.data?.map((eachRow, index) => (
                    <SubscribeTableData
                      key={eachRow.id}
                      data={eachRow}
                      index={index}
                      currentPage={subscriberReqList?.pagination?.currentPage}
                    />
                  ))}
                </>
              ) : (
                <>
                  <tr>
                    <td
                      colSpan="1"
                      className="text-center no-data-container fs_16"
                    >
                      <span>~ No Data Found ~</span>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
        <div className={loading === true ? `loading-event` : ""}>
          {subscriberReqList?.pagination?.totalPages > 0 && (
            <NumberPagination
              setCurrentPage={setPage}
              pagination={subscriberReqList?.pagination?.currentPage}
              totalPages={subscriberReqList?.pagination?.totalPages}
              path={"/customers/onboarding-pharmacy"}
              filters={`${queryString}`}
            />
          )}
        </div>
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </>
  );
};

export default SubscribePharmacyTable;
